import switchOnEnableImg from "../assets/icons/switch-on@2x.png";
import switchOffEnableImg from "../assets/icons/switch-off@2x.png";
var switchData = {
  name: 'switch',
  data: [{
    onEnableImage: switchOnEnableImg,
    offEnableImage: switchOffEnableImg,
    switchWrapperHeight: 21,
    switchHeight: 18,
    switchWidth: 52,
    switchBg: 'rgba(0,0,0,0.25)',
    switchOnBg: 'rgba(59,135,245,0.4)',
    radius: 0,
    handleRadius: 2,
    handleWidth: 28,
    handleHeight: 20,
    loadingInnerSize: 16,
    loadingInnerTop: 3,
    loadingInnerLeft: 6,
    loadingInnerRight: -2,
    loadingInnerStroke: 'rgb(79, 125, 231)',
    innerMarginLeft: 32
  }]
};
export default switchData;